// extracted by mini-css-extract-plugin
export default {"field":"InformationEdit_field__dvtdT","text":"InformationEdit_text__tDdHF"};